import { differenceInMinutes } from "date-fns";
import { toZonedTime } from "date-fns-tz";

import { compareNumbers } from "../../../../lib/helpers/compareNumbersAsString";
import { DeviceFields } from "../../../../api/graphql/devices/devices";
import {
  CONNECTION_STATUS_LABEL,
  CONNECTION_STATUS_ORDER,
} from "./constants";
import { ConnectionStatus } from "./types";

export const getConnectionStatus = (
  device: DeviceFields,
  timeZone: string
): ConnectionStatus => {
  const version = device.softwareInfo?.version;

  if (
    device.typeOfWorkspace === "room" &&
    version &&
    process.env.REACT_APP_RDX_VERSION &&
    compareNumbers(version, process.env.REACT_APP_RDX_VERSION) < 0
  ) {
    return "app_update_required";
  }

  if (
    device.typeOfWorkspace === "wayFinder" &&
    version &&
    process.env.REACT_APP_WFX_VERSION &&
    compareNumbers(version, process.env.REACT_APP_WFX_VERSION) < 0
  ) {
    return "app_update_required";
  }

  if (!device.lastDevicePing) {
    return "offline";
  }

  const lastPingDate = toZonedTime(
    new Date(device.lastDevicePing * 1000),
    timeZone
  );
  const minutesDiff = differenceInMinutes(
    toZonedTime(new Date(), timeZone),
    lastPingDate
  );
  const hoursDiff = minutesDiff / 60;

  if (hoursDiff < 16.5) {
    return "online";
  }

  if (hoursDiff <= 24.5) {
    return "warning";
  }

  return "offline";
};

export const toSemverValue = (version?: string | null) => {
  if (!version || version === "undefined") {
    return -1;
  }

  const [major = 0, minor = 0, patch = 0] = version
    .split(".")
    .map((segment) => Number(segment.trim()))
    .map((segment) => (Number.isNaN(segment) ? 0 : segment));

  return major * 1_000_000 + minor * 1_000 + patch;
};

export const getConnectionSortMeta = (status: ConnectionStatus) => ({
  connectionOrder: CONNECTION_STATUS_ORDER[status],
  connectionLabel: CONNECTION_STATUS_LABEL[status],
});
